import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Helmet } from "react-helmet";
import * as Sentry from "@sentry/browser";

import * as serviceWorker from "./serviceWorker.js";

import store from "./store.js";
import { apiBaseUrl } from "apis/apiHelpers.js";

import App from "components/App/App.jsx";
import "localisation/i18n";
import { Suspense } from "react";
import localFontPreloader from "utils/localFontPreloader";

Sentry.init({
  dsn: "https://6603975fc1e34f7897a1c729f44addee@sentry.io/2258210"
});

// Add global error handler to catch script errors
window.addEventListener('error', (event) => {
  // Prevent the error from bubbling up
  event.preventDefault();
  return false;
});

// Add unhandled promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
  // Prevent the error from bubbling up
  event.preventDefault();
  return false;
});

// Preload local fonts to prevent FOUT (Flash of Unstyled Text)
localFontPreloader.preloadAllFonts().catch(() => {
  // Failed to preload local fonts - continue anyway
});

ReactDOM.render(
  <Provider store={store}>
    <Helmet>
      <link
        rel="stylesheet"
        type="text/css"
        key="index-css"
        href={`${apiBaseUrl}/webslidemenu/index.css`}
      />
    </Helmet>
    <Suspense fallback="...is loading">
      <App />
    </Suspense>
  </Provider>,
  document.getElementById("react-app-root")
);

serviceWorker.unregister();

window.onbeforeunload = () => {
  sessionStorage.removeItem("authToken");
};
